// Shared terminology from jotmo-frontend/tools/i18n/lang/en_us.json.
// Only exact application-copy matches are retained, never user content.
export const mobileEnglish: Record<string, string> = {
  "模型选择": "Model selection",
  "关闭": "Close",
  "清除上下文": "Clear context",
  "取消": "Cancel",
  "确认": "Confirm",
  "重试": "Retry",
  "刷新": "Refresh",
  "支付方式": "Payment method",
  "创建 Bot": "Create Bot",
  "接入方式": "Integration Method",
  "消息免打扰": "Mute notifications",
  "关键词": "Keyword",
  "回到今日": "Back to Today",
  "加载中…": "Loading...",
  "AI 摘要": "AI Summary",
  "我": "Me",
  "通话": "Call",
  "分享": "Share",
  "返回": "Back",
  "复制链接": "Copy link",
  "添加联系人": "Add Contact",
  "扫一扫二维码添加好友": "Scan QR code to add friend",
  "添加": "Add",
  "加载失败，点击重试": "Load failed. Tap to retry.",
  "没有更多了": "No more",
  "已移除对话，可在联系人中找回": "Conversation removed. Find it again in Contacts",
  "最近删除": "Recently Deleted",
  "恢复": "Restore",
  "最近使用": "Recent",
  "默认表情": "Emoji",
  "创作者：牛mo王": "Creator: Niu Mo Wang",
  "加载失败": "Load failed",
  "上传中": "Uploading",
  "点击重试": "Tap to retry",
  "处理中": "Processing",
  "选择图片": "Select image",
  "知道了": "Got it",
  "复制": "Duplicate",
  "打开": "Open",
  "打开文件夹": "Open folder",
  "邀请链接已复制": "Invite link copied",
  "重命名": "Rename",
  "字": "words",
  "详情": "Details",
  "关于": "About",
  "创建时间": "Creation time",
  "确认删除": "Delete",
  "开通": "Activate",
  "加载中...": "Loading...",
  "暂无更多人员信息": "No more personnel information yet",
  "字数": "Words",
  "记录时长": "Duration",
  "查阅/回顾": "Review",
  "次": "times",
  "共": "Total",
  "已编辑": "Edited",
  "我的世界": "My World",
  "数据管理": "Data Management",
  "设置": "Settings",
  "创建群聊": "Create Group Chat",
  "最新": "Latest",
  "暂无数据": "No Data",
  "相关快记": "Related Notes",
  "快速查找": "Quick search",
  "文字背景音": "Text background audio",
  "即我号": "Arkme ID",
  "确认创建": "Confirm Create",
  "手机号": "Phone number",
  "验证码": "Verification Code",
  "重新编辑:": "Re-edit:",
  "指定主题": "Move to",
  "删除": "Delete",
  "发给自己": "Send to Self",
  "默认分类": "Default Category",
  "全部": "All",
  "当前主题": "Current topic",
  "最多": "Most",
  "主题名称": "Topic Name",
  "主题": "Topics",
  "日历": "Calendar",
  "新建主题": "New Topic",
  "世界": "World",
  "发布": "Publish",
  "图片": "Image",
  "收起": "Less",
  "退出": "Exit",
  "我的": "Profile",
  "他人": "Others",
  "上传文件": "Upload file",
  "已完成": "Completed",
  "点击、拖拽上传音频文件（支持多选）": "Click or drag to upload audio files (multiple selection supported)",
  "文件名称": "File Name",
  "录音时长": "Recording Duration",
  "文件大小": "File Size",
  "数据归属": "Data Ownership",
  "上传状态": "Upload status",
  "导入": "Import",
  "确定修改音频文件的数据归属吗？": "Confirm modifying audio file data attribution?",
  "我的数据写入时间轴，他人仅保存": "My data is written to the timeline, others are only saved.",
  "状态": "Status",
  "开始时间": "Start",
  "即我": "Arkme",
  "今天": "Today",
  "安排": "Schedule",
  "录音": "Recording",
  "单击文字，长按语音": "Tap to text, hold to speak",
  "快记": "Notes",
  "时间轴": "Timeline",
  "总结": "Summary",
  "转写": "Transcription",
  "文件": "File",
  "我知道了": "Got it",
  "滚轮缩放": "Wheel zoom",
  "无录音": "No Recording",
  "导入音频": "Import Audio",
  "背景音": "Background Sound",
  "秒": "Sec",
  "昵称": "Name",
  "备注": "Note",
  "编辑": "Edit",
  "修改备注": "Edit",
  "天": "days",
  "发送消息": "Message",
  "描述这个 Bot 的用途": "Describe what this Bot is for",
  "输入手机号或即我号": "Enter phone number or Arkme ID",
  "收藏表情": "Favorite Stickers",
  "快记详情": "Note details",
  "已置顶": "Pinned",
  "月": "Month",
  "导出": "Export",
  "设置即我号": "Set Arkme ID",
  "请输入即我号": "Enter Arkme ID",
  "请输入验证码": "Enter code",
  "账户": "Account",
  "通知": "Notifications",
  "用户协议": "User agreement",
  "隐私条款": "Privacy Terms",
  "记录此刻想法...": "Capture the moment...",
  "Enter发送 / Shift+Enter换行": "Enter to send / Shift+Enter for new line",
  "搜索主题名": "Search Topic Name",
  "请输入主题名称": "Please enter topic name",
  "联系作者": "Contact the author",
  "私密": "Private",
  "全选": "Select all",
  "输入名称": "Enter name",
  "推荐说话人": "Recommended Speaker",
  "已添加说话人": "Speaker Added",
  "缩小": "Minimize",
  "放大": "Zoom In",
  "读取中": "Reading",
  "处理失败": "Processing failed",
  "长文": "Article",
  "请输入 Bot 名称": "Please enter Bot name",
  "头像处理中...": "Processing avatar...",
  "创建中...": "Creating...",
  "一": "One",
  "二": "Two",
  "三": "Three",
  "四": "Four",
  "五": "Five",
  "六": "Six",
  "日": "Day",
  "暂无记录": "No records yet",
  "视频": "Video",
  "转写失败": "Failed to transcribe...",
  "语音": "Voice",
  "查看个人主页": "View Profile",
  "操作失败，请重试": "Operation failed. Please try again.",
  "下一步": "Next",
  "外部链接": "External link",
  "这个月": "This month",
  "通话记录": "Call records",
  "移至最前": "Move to Front",
  "刚刚": "Just now",
  "暂无文件": "No Files Available",
  "保存成功": "Save successful",
  "已复制": "Copied",
  "待绑定": "Connect",
  "发起人": "Admin",
  "确认添加": "Confirm Add",
  "已开启": "Enabled",
  "聊天记录": "Chat records",
  "退出群聊": "Leave Group Chat",
  "分享链接": "Share link",
  "高": "High",
  "中": "M",
  "低": "Low",
  "已关闭": "Closed",
  "链接已复制": "Link copied",
  "私聊": "Private chat",
  "分享失败，请重试": "Share failed, please try again",
  "多选": "Select",
  "昨天": "Yesterday",
  "前天": "2 days ago",
  "本周": "This week",
  "上周": "Last week",
  "本月": "#-day Streak\nDuration: # mins\nNotes created: #\nWords logged: #\nTopics engaged: #\n# searches, # reviews, # shares",
  "上月": "Last month",
  "其他": "Other",
  "提交": "Submit",
  "未记录": "Not recorded",
  "（充电中）": "(charging)",
  "（暂停充电）": "(charging paused)",
  "暂无详细位置信息": "No detailed location information yet",
  "未录制背景音": "No background sound recorded",
  "未开启背景音": "Background sound off",
  "天气": "Weather",
  "海拔": "Alt.",
  "移动状态": "Motion",
  "终端": "Device",
  "设备电量": "Battery",
  "网络": "Network",
  "归属日期": "Log Date",
  "完成时间": "End",
  "同步时间": "Synced",
  "同步中": "Syncing",
  "同步失败": "Sync failed",
  "已同步": "Synced",
  "默认": "Default",
  "编辑记录": "Edited History",
  "开启": "On",
  "去开启": "Enable",
  "对话": "We've talked",
  "添加 Bot": "Add Bot",
  "删除的内容将在数据管理中保留30天": "Deleted content will be retained in data management for 30 days",
  "已在当前主题中！": "Already in current topic!",
  "暂无转写内容，快去录音吧！": "No transcription content available, go record now!",
  "生成总结中...": "Generating summary...",
  "总结生成失败，": "Summary Generation Failed,",
  "暂无总结内容，": "No summary content available,",
  "生成时间轴中...": "Generating timeline...",
  "时间轴生成失败，": "Timeline Generation Failed,",
  "暂无时间轴内容，": "No timeline content available,",
  "点击生成总结": "Click to generate summary",
  "点击生成时间轴": "Click to generate timeline",
  "当前无内容可导出": "No Content Available for Export",
  "最大化": "Maximize",
  "导入历史音频": "Import Historical Audio",
  "展开": "More",
  "已绑定": "Connected",
  "绑定": "Bind",
  "即我号不能以数字或符号开头": "Arkme ID cannot start with a number or symbol",
  "即我号仅支持字母、数字、下划线或减号": "Arkme ID only supports letters, numbers, underscores, or hyphens",
  "即我号需要5-20个字符": "Arkme ID must be 5-20 characters",
  "即我号需要6-20个字符": "Arkme ID must be 6-20 characters",
  "服务器繁忙，请稍后重试": "Server busy, please try again later",
  "即我用户": "User",
  "即我号仅可设置一次，创建成功后不可修改，是否继续？": "Arkme ID can only be set once and cannot be changed after creation. Continue?",
  "绑定手机号": "Bind phone number",
  "更换手机号": "Change phone number",
  "请输入正确的手机号": "Please enter correct phone number",
  "已发送验证码": "Verification code sent",
  "失败": "Failed",
  "请输入": "Please enter",
  "绑 定": "Bind",
  "更 换": "Change",
  "暂未获取到即我号": "Arkme ID not available",
  "退出登录": "Log out",
  "延展": "Quote",
  "重新编辑": "Re-edit",
  "举报": "Report",
  "邀请": "Invite",
  "发送中": "Sending",
  "所有人": "Everyone",
  "请先完成编辑后再进行延展": "Please complete editing first before quote",
  "复制链接失败，请稍后重试": "Failed to copy link. Please try again later.",
  "解散中": "Dissolving",
  "新建子主题": "Create subtopic",
  "创建主题": "Create topic",
  "[有人@我] ": "[Mentioned me] ",
  "取消置顶": "Unpin",
  "置顶对话": "Pin conversation",
  "移除": "Remove",
  "刷新中": "Refreshing",
  "已": "Already",
  "免费版": "Free version",
  "未命名": "Unnamed",
  "未知": "Unknown",
  "未分类快记": "Uncategorized Notes",
  "[图片]": "[Image]",
  "[语音]": "[Voice]",
  "[视频]": "[Video]",
  "[文件]": "[File]",
  "阿森": "Arko",
  "麦克风": "Microphone",
  "移动网络": "Mobile network",
  "仅支持1970年至今的日期": "Only supports dates from 1970 to present",
  "未开启": "Not enabled",
  "等待中": "Waiting",
  "待导入": "Pending Import",
  "继续": "Continue",
  "识别中": "Detecting",
  "周日": "Sunday",
  "周一": "Monday",
  "周二": "Tuesday",
  "周三": "Wednesday",
  "周四": "Thursday",
  "周五": "Friday",
  "周六": "Saturday",
  "加载失败，请重试": "Load failed, please try again"
}
